import { Pressable } from "react-native";
import { MoonText as Text } from "@louise/moon-ui/primitives/MoonText";
import { Plus } from "lucide-react-native";
import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";

const TEXT_MID = "#5A4D45";
const BROWN = "#794633";

type Props = {
  label: string;
  onPress?: () => void;
  variant?: "neutral" | "add";
  disabled?: boolean;
};

export default function CycleRecordRowActionButton({
  label,
  onPress,
  variant = "neutral",
  disabled = false,
}: Props) {
  const isAdd = variant === "add";
  const capturePress = usePressCapture("CycleRecordRowActionButton");

  return (
    <Pressable
      onPress={
        onPress
          ? () => {
              // `label` is caller-supplied copy, so pair it with a stable action.
              capturePress(pressLabel(label), "cycle_record_row_action");
              onPress();
            }
          : undefined
      }
      disabled={disabled || !onPress}
      accessibilityRole={onPress ? "button" : undefined}
      accessibilityLabel={label}
      style={({ pressed }) => ({
        flexDirection: "row",
        alignItems: "center",
        gap: 4,
        borderRadius: 999,
        paddingHorizontal: 9,
        paddingVertical: 6,
        backgroundColor: isAdd ? "rgba(121,70,51,0.1)" : "rgba(0,0,0,0.04)",
        opacity: pressed ? 0.68 : disabled ? 0.48 : 1,
      })}
    >
      {isAdd ? <Plus size={11} color={BROWN} strokeWidth={2.1} /> : null}
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 11,
          lineHeight: 13,
          color: isAdd ? BROWN : TEXT_MID,
          fontWeight: "800",
        }}
      >
        {label}
      </Text>
    </Pressable>
  );
}
